// src/utils/cookieUtils.js
export const hasConsented = () => {
  return document.cookie.includes("matrix180_cookie_consent=true");
};

export const hasDeclined = () => {
  return document.cookie.includes("matrix180_cookie_consent=false");
};
